export default __webpack_public_path__ + "static/media/file1.14689651.png";